import axios from 'axios';
import config from '../../../static/config.json';

// 微信分享
const state = {
	exhibitorId: null, // 参展的id 
	companyId: null, // 公司的id
}
const mutations = {
	setExhibitorId(state, data) { // 设置参展的id
		state.exhibitorId = data;
	},
	setCompanyId(state, data) { // 设置公司的id
		state.companyId = data;
	},
}
const getters = {
	getExhibitorId: (state) => {
		return state.exhibitorId;
	},
	getCompanyId: (state) => {
		return state.companyId;
	}
}
const actions = {
	getCompany({ rootState, state, getters, commit }) {
		return new Promise((resolve, reject) => {
			axios.get(`${config.https.api}/api/v1/exhibitor/details?exhibitorId=${getters.getExhibitorId}`, rootState.tokenHeaders)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
						commit('setCompanyId', res.data.compId);
					}
				})
				.catch(err => console.log(err));
		});
	},
	getProListByCompId({ rootState, getters, commit }, body) {
		return new Promise((resolve, reject) => {
			axios.post(`${config.https.api}/api/v1/product/query`, body, rootState.header).then(data => {
				if (data.data && data.data.items.length) {
					data.data.items.map(c => {
						if (c.banner.search(/^\[/) !== -1) {
							c.banner = JSON.parse(c.banner);
						} else {
							c.banner = [];
						}
					})
					resolve(data.data);
				} else {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	getProListByTj({ rootState, getters, commit }, body) {
		return new Promise((resolve, reject) => {
			axios.get(`${config.https.api}/api/v1/product/getuserpagedshortforexhibitor?ExhibitorId=${body.exhibitorId}&pageIndex=${body.page}&pageSize=${body.size}`, rootState.header).then(data => {
				if (data.data && data.data.items.length) {
					data.data.items.map(c => {
						if (c.banner.search(/^\[/) !== -1) {
							c.banner = JSON.parse(c.banner);
						} else {
							c.banner = [];
						}
					})
					resolve(data.data);
				} else {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	getAllCompany({ rootState, state, getters, commit }, body) {
		return new Promise((resolve, reject) => {
			axios.get(`${config.https.api}/api/v1/exhibitor/getexhibitorpage?exhibitorId=${body.id}&userId=${body.userId}&pageSize=10`, rootState.tokenHeaders)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
						commit('setCompanyId', res.data.exInfo.compId);
					}
				})
				.catch(err => console.log(err));
		});
	},
	getProduct({ rootState, state, getters, commit }, body) {
		return new Promise((resolve, reject) => {
			axios.get(`${config.https.api}/api/v1/product/getproductpage?productId=${body.id}&userId=${body.userId}&pageSize=10`, rootState.tokenHeaders)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	addCompView({ rootState }, body) {
		return new Promise((resolve,reject) => {
			axios.post(`${config.https.api}/api/v3/addview`, body, rootState.header)
				.then(res => {
					if (res.status&&res.data) {
						resolve(res.data);
					}
				})
				.catch(err => resolve(false));
		})
	},
	addCompLove({ rootState }, body) { // 添加展商关注
		return new Promise((resolve, reject) => {
			axios.post(`${config.https.api}/api/v1/exhibitor/follow`, body, rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	tipComp({ rootState }, body) { // 举报展商
		return new Promise((resolve, reject) => {
			axios.post(`${config.https.api}/api/v1/exhibitorreport`, body, rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	delCompLove({ rootState }, body) { // 取消展商关注
		return new Promise((resolve, reject) => {
			axios.delete(`${config.https.api}/api/v1/exhibitor/follow`, { data: body, ...rootState.header })
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	addProView({ rootState }, body) {
		axios.post(`${config.https.api}/api/v1/productviewer`, body, rootState.header)
			.then(res => {
				if (res.status === 200 && res.data) {
					//    console.log(res,'浏览记录')
				}
			})
			.catch(err => console.log(err));
	},
	addProLove({ rootState }, body) { // 添加产品关注
		return new Promise((resolve, reject) => {
			axios.post(`${config.https.api}/api/v1/productfollower`, body, rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	addEnquiry({ rootState }, body) { // 添加询盘
		return new Promise((resolve, reject) => {
			axios.post(`${config.https.api}/api/v1/exhibitorenquiry`, body, rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	getHotList({ rootState }, body) { // 获取热榜
		return new Promise((resolve, reject) => {
			axios.post(`${config.https.api}/api/v1/livepopularize/ranking`, body, rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	getHotRankTop({ rootState }, body) { // 获取前几个热榜排名
		return new Promise((resolve, reject) => {
			axios.get(`${config.https.api}/api/v1/livepopularize/top?roomId=${body.roomId}&topNum=3&userNum=5`, rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	getRoomTopUser({ rootState }, body) {  // 获取房间的顶部前几个用户数据
		return new Promise((resolve, reject) => {
			axios.get(`${config.https.api}/api/v1/liveviewer/top-user?roomId=${body.roomId}&topNum=3`, rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	getRoomTopUserNew({ rootState }, body) {  // 获取房间的顶部前几个用户数据
		return new Promise((resolve, reject) => {
			axios.get(`${config.https.api}/api/v1/liveviewer/exhibition/top-user?exhibitionId=${body.exhibitionId}&topNum=3`, rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	addRoomViewer({ rootState }, body) {  // 添加直播间的观众信息;
		return new Promise((resolve, reject) => {
			axios.post(`${config.https.api}/api/v1/liveviewer`, body, rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	addhotViewer({ rootState }, body) { // 添加热榜的浏览记录
		axios.post(`${config.https.api}/api/v1/livepopularize/viewer`, body, rootState.header)
			.then(res => {
				console.log(res, 'res123')
				if (res.status === 200 && res.data) {
					// resolve(res.data);
				}
			})
			.catch(err => console.log(err));
	},
	addhotShare({ rootState }, body) { // 添加热榜的分享记录
		axios.post(`${config.https.api}/api/v1/livepopularize/share`, body, rootState.header)
			.then(res => {
				console.log(res, 'res123')
				if (res.status === 200 && res.data) {
					// resolve(res.data);
				}
			})
			.catch(err => console.log(err));
	},
	//展商秀新增
	//用户评价展商
	userExEvaluate({ rootState }, body) {
		return new Promise((resolve, reject)=>{
			axios.post(`${config.https.api}/api/v3/exhibitorevaluate`, body, rootState.header)
			.then(res => {
				// console.log(res, 'res123')
				if (res.status === 200 && res.data) {
					resolve(res.data);
				}
			})
			.catch(err => console.log(err));
		})
	},
	//展品评价
	ProductEvaluate({ rootState }, body) {
		return new Promise((resolve, reject)=>{
			axios.post(`${config.https.api}/api/v3/productevaluate`, body, rootState.header)
				.then(res => {
					// console.log(res, 'res123')
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		})
	},
	//点赞展商
	exLike({ rootState }, body) {
		return new Promise((resolve, reject)=>{
			axios.post(`${config.https.api}/api/v3/exhibitorlike`, body, rootState.header)
			.then(res => {
				// console.log(res, 'res123')
				if (res.status === 200 && res.data) {
					resolve(res.data);
				}
			})
			.catch(err => console.log(err));
		})
	},
	//点赞展品
	ProductLike({ rootState }, body) {
		return new Promise((resolve, reject)=>{
			axios.post(`${config.https.api}/api/v3/productlike`, body, rootState.header)
				.then(res => {
					// console.log(res, 'res123')
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		})
	},
	//产品关注
	ProductFollower({ rootState }, body) {
		return new Promise((resolve, reject)=>{
			axios.post(`${config.https.api}/api/v1/productfollower`, body, rootState.header)
				.then(res => {
					console.log(res, 'res123')
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		})
	},
	RemoveProductFollower({ rootState }, body) {
		return new Promise((resolve, reject)=>{
			axios.post(`${config.https.api}/api/v1/productfollower`, body, rootState.header)
				.then(res => {
					// console.log(res, 'res123')
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		})
	},
	//展品浏览
	Productviewer({ rootState }, body) {
		return new Promise((resolve, reject)=>{
			axios.post(`${config.https.api}/api/v3/addview`, body, rootState.header)
				.then(res => { 
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		})
	},

	//搜索话题
	TopicSearch({
					rootState,
					commit
				}, opt) {
		return new Promise((resolve, reject) => {
			axios.post(`${config.https.api}/api/v3/theme/search`, opt, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},

	
	// 添加预约洽谈
	addOrder({
				rootState,
				commit
			}, opt) {
		return new Promise((resolve, reject) => {
		axios.post(`${config.https.api}/api/v3/exhibitorappointment`, opt, rootState.header).then(data => {
			if (data.data) {
				resolve(data.data);
			}
		}).catch((err) => {
			console.log(err);
		});
		});
	},

	addEnquiryNew({
		rootState
	}, body) { // 添加询盘（新）
		return new Promise((resolve, reject) => {
			axios.post(`${config.https.api}/api/v3/exhibitornewenquiry`, body, rootState.header)
				.then(res => {
					if (res.status === 200 && res.data) {
						resolve(res.data);
					}
				})
				.catch(err => console.log(err));
		});
	},
	//再次编辑讨论
	editEnquiryNew({
		rootState,
		commit
	}, opt) {
		return new Promise((resolve, reject) => {
			axios.put(`${config.https.api}/api/v3/exhibitornewenquiry/patch?id=${opt.id}`, opt.opt, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	addAppointmentNumber({
		rootState,
		commit
	}, id) {
		return new Promise((resolve, reject) => {
			axios.post(`${config.https.api}/api/v3/exhibitorappointmentagora/add/number?exhibitorId=${id}`, {
				exhibitorId: id
			}, rootState.header).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
}
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
}
